import { render, staticRenderFns } from "./ProductsCategoryChangeDialog.vue?vue&type=template&id=5954221f&scoped=true"
import script from "./ProductsCategoryChangeDialog.vue?vue&type=script&lang=js"
export * from "./ProductsCategoryChangeDialog.vue?vue&type=script&lang=js"
import style0 from "./ProductsCategoryChangeDialog.vue?vue&type=style&index=0&id=5954221f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5954221f",
  null
  
)

export default component.exports